import { useMutation } from "@tanstack/react-query"
import { apiClient } from "~/lib/client"
import { BookingFormData } from "../../schemas"
import { handleError } from "~/utils/response"
import { handleResponse } from "~/utils/response"

import { CreateAppointmentResponseData, CreateAppointmentResponse } from "../types"


export const useCreateAppointmentBookingMutation = () => {
    return useMutation<CreateAppointmentResponse, unknown, BookingFormData>({
        mutationFn: async (variables: BookingFormData) => {
            try {
                const response = await apiClient("/appointments", {
                    method: "POST",
                    body: JSON.stringify(variables),
                });

                return await handleResponse<CreateAppointmentResponseData>(response);
            } catch (error) {
                return handleError(error);
            }
        },
    });
};


